<template>
    <div class="item-search-control ui-form-control">
        <!-- * 已选择的选项 -->
        <div class="item-container">
            <div v-for="(value, key) in selects" class="item" :style="binds.container">
                <ui-tooltip-follow class="ellipsis">
                    <div class="ellipsis" v-html="`${$t(value.type)}:${value.name}`"></div>
                    <template #content>
                        <div v-html="`${$t(value.type)}:${value.name}`"></div>
                    </template>
                </ui-tooltip-follow>
                <ui-icon class="btn-close" name="close" @click="methods.delete(key)" />
            </div>
        </div>

        <!-- * 输入框 -->
        <input class="search-input" type="text" v-model="keyword" v-bind="binds.input" v-on="ons.input" v-if="selects.length < number" />

        <div class="flex-center">
            <!-- * 搜索按钮 -->
            <div class="btn-search font-bold color-1" @click="$emit('search', selects)">{{ $t("Search") }}</div>
        </div>

        <!-- * 候选项 -->
        <transition v-on="animations.selector(true)">
            <div class="candidates-container" v-if="visible">
                <ui-simplebar :height="288" ref="simplebar">
                    <template v-for="data in candidates">
                        <div class="candidates-type" v-if="candidates.length > 1">{{ $t(data.type) }}</div>
                        <template v-if="data.data.length">
                            <div v-for="value in data.data" class="candidate" @mousedown="methods.select(value)">
                                <div :class="{ 'candidate-name': value.alias }" class="ellipsis">
                                    <span v-if="data.type != 'Mutation'" v-html="`[${value.id}]`"></span>
                                    <span v-html="value.name"></span>
                                </div>
                                <div v-if="value.alias" class="candidate-alias ellipsis" v-html="value.alias"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="candidate-nodata">
                                {{ $t("NoData") }}
                            </div>
                        </template>
                    </template>
                </ui-simplebar>
            </div>
        </transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { animations, UiIcon, UiTooltipFollow, UiSimplebar } from "various-ui";
//* 组件属性
import { ItemSearchPropsOption, ItemSearchEmits } from "./index";
import { useComposable } from "./src/composable";

//* 组件属性注册
const define = defineProps(ItemSearchPropsOption);
const emit = defineEmits(ItemSearchEmits);

//* 组合函数
const { ons, refs, nodes, binds, methods } = useComposable(define);
const { keyword, selects, candidates, visible } = refs;
const { simplebar } = nodes;
const { update } = methods;

//* 组件卸载前销毁数据
onBeforeUnmount(() => {
    methods.cancel();
});

//* 组件属性导出
defineExpose({ update });
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
